import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e1130d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "paging"
}
const _hoisted_2 = { class: "gotoPage" }

import { PageBlockAccessSpec } from "@/services/datatype/paging/PageBlockAccessSpec";
import { ElMessage } from "element-plus";
import { onMounted, ref, computed, ComputedRef, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'paging',
  props: {
  data: {
    required: true,
    type: [Object],
    // default: 0,
  },
  pageSize: {
    required: true,
    type: Number,
    // default: 0,
  },
},
  emits: ["getData"],
  setup(__props, { emit }) {

const props = __props;

let pageBlockSpec: PageBlockAccessSpec = new PageBlockAccessSpec();
pageBlockSpec.pageSize = 3;
pageBlockSpec.maxPagesPerBatch = 1;

const state = ref(true);

//当前页码
const pagingIndex = ref<number>(1);
//输入框跳转
const activeIndex = ref<number>(1);
//显示条目
const pageSize: number = props.pageSize as number;
//总条目
const total: ComputedRef<number> = computed((): number => props.data.length);
//总页数
const totalPage: () => number = (): number =>
  Math.ceil(props.data.length / pageSize);
//监听页码变化
const handleCurrentChange = (e: number) => {
  pagingIndex.value = e;
  paginationCapture(props.data, pageSize * (e - 1), pageSize * e);
};
//跳转
const goto = () => {
  if (activeIndex.value === pagingIndex.value) return;
  if (activeIndex.value <= totalPage() && activeIndex.value > 0) {
    pagingIndex.value = Number(activeIndex.value);
    paginationCapture(
      props.data,
      pageSize * (activeIndex.value - 1),
      pageSize * activeIndex.value
    );
  } else {
    activeIndex.value = pagingIndex.value;
    ElMessage({
      message: "我是有极限的！",
      type: "warning",
    });
  }
};
const paginationCapture = (data: any, start: number, end: number) =>
  emit("getData", data.slice(start, end));
watch(props, () => {
  paginationCapture(props.data, 0, pageSize);
});
onMounted(() => {
  paginationCapture(props.data, 0, pageSize);
});

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (state.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev, pager, next",
          total: _unref(total),
          "current-page": pagingIndex.value,
          "page-size": _unref(pageSize),
          "prev-text": "上一页",
          onCurrentChange: handleCurrentChange,
          "next-text": "下一页"
        }, null, 8, ["total", "current-page", "page-size"]),
        _createElementVNode("p", null, "共" + _toDisplayString(_unref(total)) + " 条信息/" + _toDisplayString(totalPage()) + "页", 1),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: "tel",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeIndex).value = $event))
          }, null, 512), [
            [_vModelText, activeIndex.value]
          ]),
          _createElementVNode("button", {
            class: "goto",
            onClick: goto
          }, "跳转")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})